<ac-cta-link [icon]="icon" (click)="showDialog()" class="text-16-bold" [trackEvent]="linkEvent">
	<ng-content></ng-content>
</ac-cta-link>
